import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { isMobileState } from '@/store/atom';
import { useNewsBriefing } from './_context/NewsContext';
import { PaginationIndicator } from './_components/PaginationIndicator';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi,
} from '@/components/atoms/Carousel';
import { NewsCard } from './_components/NewsCard';
import { NewsHeader } from './_components/NewsHeader';
import { ApageOverview, BpageOverview } from './_components/NewsOverview';
import { CarouselNavigationButtons } from './_components/CarouselNaviagtionButtons';
import {
  LayoutBottomContent,
  LayoutNewsBriefingSwiper,
  LayoutSwiperTop,
  LayoutTopContent,
} from './_layouts/LayoutNewsBriefingSwiper';
import { Skeleton } from '@/components/atoms/PcSkeleton';

// 컴포넌트 매핑 함수 (컴포넌트 타입을 반환)
const getOverviewComponent = (group?: string) => {
  switch (group) {
    case 'apage':
      return ApageOverview;
    case 'bpage':
      return BpageOverview;
    default:
      return null;
  }
};

export const NewsBriefingSwiper = () => {
  const isMobile = useRecoilValue(isMobileState);
  const { group } = useParams<{ group: string }>();

  const { data, isLoading } = useNewsBriefing();
  const date = data?.date || new Date().toISOString();
  const ecommerceTopicList = data?.ecommerceTopicList || [];

  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) return;

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());

    api.on('select', () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);

  // overview 컴포넌트 동적 삽입
  const OverviewComponent = getOverviewComponent(group);
  const overviewIndex = ecommerceTopicList.length;

  if (isLoading) {
    return <NewsBriefingLoading />;
  }
  return (
    <LayoutNewsBriefingSwiper>
      <LayoutSwiperTop>
        <NewsHeader date={date} />
        <LayoutTopContent>
          <Carousel className="h-full w-full " setApi={setApi}>
            <CarouselContent className="h-full">
              {ecommerceTopicList.map((item, index) => (
                <CarouselItem key={`news-${index}`}>
                  <NewsCard item={item} active={current === index} />
                </CarouselItem>
              ))}
              {OverviewComponent && (
                <CarouselItem key={`overview-${group}`}>
                  <OverviewComponent active={current === overviewIndex} />
                </CarouselItem>
              )}
            </CarouselContent>

            {!isMobile && <CarouselNavigationButtons />}
          </Carousel>
        </LayoutTopContent>
      </LayoutSwiperTop>

      <LayoutBottomContent>
        <PaginationIndicator
          total={count}
          currentIndex={current}
          onDotClick={(index) => api?.scrollTo(index)}
        />
      </LayoutBottomContent>
    </LayoutNewsBriefingSwiper>
  );
};

export const NewsBriefingLoading = () => {
  // const date = new Date().toISOString();
  return (
    <LayoutNewsBriefingSwiper>
      {/* <NewsHeader date={date} /> */}
      <div className="flex w-full justify-between">
        <Skeleton className="h-[24px] w-[162px] max-w-full" />
        <Skeleton className="h-[24px] w-[99px] max-w-full" />
      </div>
      <LayoutTopContent>
        <div className="flex h-full w-full flex-1 flex-col gap-[20px] overflow-y-auto overflow-x-hidden rounded-[12px] border bg-white p-[20px]">
          <div className="flex flex-col gap-[8px] ">
            <Skeleton className="h-8 w-[250px] max-w-full" />
            <Skeleton className="h-8 w-[150px] max-w-full" />
          </div>
          <div className="flex flex-col space-y-2">
            <Skeleton className="h-4 w-[250px] max-w-full" />
            <Skeleton className="h-4 w-[200px] max-w-full" />
            <Skeleton className="h-4 w-[280px] max-w-full" />
            <Skeleton className="h-4 w-[270px] max-w-full" />
            <Skeleton className="h-4 w-[290px] max-w-full" />
          </div>
          <div className="flex">
            <Skeleton className="h-[150px] w-full max-w-full" />
          </div>
          <div className="flex flex-col gap-[8px]">
            <Skeleton className="h-4 w-[150px] max-w-full" />

            <Skeleton className="h-[150px] w-full max-w-full" />
          </div>
        </div>
      </LayoutTopContent>
      <LayoutBottomContent>
        <div className="flex gap-[6px]">
          <Skeleton className="h-[6px] w-[16px] rounded-full" />
          <Skeleton className="h-[6px] w-[6px] rounded-full" />
          <Skeleton className="h-[6px] w-[6px] rounded-full" />
          <Skeleton className="h-[6px] w-[6px] rounded-full" />
          <Skeleton className="h-[6px] w-[6px] rounded-full" />
          <Skeleton className="h-[6px] w-[6px] rounded-full" />
          <Skeleton className="h-[6px] w-[6px] rounded-full" />
        </div>
      </LayoutBottomContent>
    </LayoutNewsBriefingSwiper>
  );
};
